export const settingsModalProps = {
  height: '270px',
  width: '600px',
  maxWidth: 1000,
  maxHeight: 400,
  name: 'modal-settings',
  resizable: true,
  clickToClose: true,
  dialog: false,
};

export const uploadModalProps = {
  height: '700px',
  width: '600px',
  maxWidth: 1000,
  maxHeight: 1000,
  name: 'modal-upload',
  resizable: true,
  clickToClose: true,
};
